export default __webpack_public_path__ + "static/sprinkle-pattern-7661cb0163dafc3f0c3d82cadaefb2a9.svg";